const version = {
  major: 2,
  minor: 4,
  fix: 1,
};

export const getFrontendVersion = () => {
  return `${version.major}.${version.minor}${version.fix ? '.' + version.fix : ''
    }`;
};
